class SnippetManager {

    public codeSnippets = [

        {
            name: "get cell",
            code: 'async function getCell () {\n\tvar await cell = await ActiveWorkbook.getCellSerialized({ sheet: 0, row: 2, col: 4});\n\tconsole.log(cell);\n\tawait API.updateUI();\n}\n\n'
        },
        {
            name: "set cell",
            code: 'async function setCell () {\n\tawait ActiveWorkbook.setCellContents({ sheet: 0, row: 1, col: 1 }, "hello world");\n\tawait API.updateUI();\n}\n\n'
        },
        {
            name: "ONLOADED",
            code: 'async function ONLOADED() {\n\t$(document).ready(async function() {\n\t\tconsole.log("DOM loaded");\n\t\tawait API.updateUI();\n\t});\n}\n\n'
        },

        {
            name: "object mouse enter",
            code: 'async function ONENTER(object) {\n\tconsole.log("blue ", object);\n\tobject.material.color.set("#ff0000");\n\t// await ActiveWorkbook.setCellContents(\n\t// { sheet: 0, row: 35, col: 5}, "#ff0000;0.15;0.8;0.4;1"\n\t// );\n\n\tawait API.updateUI();\n}\n\n'
        },
        {
            name: "object mouse leave",
            code: 'async function ONLEAVE(object) {\n\tconsole.log("blue ", object);\n\tobject.material.color.set("#ff0000");\n\t// await ActiveWorkbook.setCellContents(\n\t// { sheet: 0, row: 35, col: 5}, "#ff0000;0.15;0.8;0.4;1"\n\t// );\n\n\tawait API.updateUI();\n}\n\n'
        },

        {
            name: "project selected",
            code: 'async function projectSelected(project) {\n\tconsole.log("project selected", project);\n\tawait API.updateUI();\n}\n\n'
        },
        {
            name: "project deselected",
            code: 'async function projectDeselected(project) {\n\tconsole.log("project deselected", project);\n\tawait API.updateUI();\n}\n\n'
        },

        {
            name: "sheet selected",
            code: 'async function sheetSelected(sheet) {\n\tconsole.log("sheet selected", sheet);\n\tawait API.updateUI();\n}\n\n'
        },
        {
            name: "sheet deselected",
            code: 'async function sheetDeselected(sheet) {\n\tconsole.log("sheet deselected", sheet);\n\tawait API.updateUI();\n}\n\n'
        },

        // Connector-related code snippets
        {
            name: "connectorSelected",
            code: 'async function connectorSelected(connectorData) {\n\tconsole.log("Connector selected:", connectorData);\n\t// Access connector properties\n\tconst label = connectorData.label;\n\tconst position = connectorData.position;\n\tconst normal = connectorData.normal;\n\tconst type = connectorData.type;\n\t\n\t// Your custom logic here\n\tawait API.updateUI();\n}\n\n'
        },
        {
            name: "getAllConnectors",
            code: 'async function getAllConnectors() {\n\tconst connectors = scene.getConnectors();\n\tconsole.log("All connectors:", connectors);\n\treturn connectors;\n}\n\n'
        },
        {
            name: "createDynamicConnector",
            code: 'async function createDynamicConnector() {\n\t// Get position from spreadsheet\n\tconst xCell = await ActiveWorkbook.getCellSerialized({ sheet: 0, row: 2, col: 1});\n\tconst yCell = await ActiveWorkbook.getCellSerialized({ sheet: 0, row: 2, col: 2});\n\tconst zCell = await ActiveWorkbook.getCellSerialized({ sheet: 0, row: 2, col: 3});\n\t\n\tconst position = `(${xCell},${yCell},${zCell})`;\n\t\n\tscene.createConnector({\n\t\tposition: position,\n\t\tnormal: "(0,1,0)",\n\t\tlabel: "Dynamic",\n\t\tshowArrow: true\n\t});\n\t\n\tawait API.updateUI();\n}\n\n'
        },
        {
            name: "updateConnectorPosition",
            code: 'async function updateConnectorPosition(connectorId, newPosition) {\n\tscene.updateConnector(connectorId, {\n\t\tposition: newPosition\n\t});\n\tawait API.updateUI();\n}\n\n'
        },
        {
            name: "filterConnectorsByType",
            code: 'async function filterConnectorsByType(type, visible = true) {\n\tconst connectors = scene.getConnectors();\n\tconnectors.forEach(connector => {\n\t\tif (connector.userData.connectorType === type) {\n\t\t\tconnector.visible = visible;\n\t\t}\n\t});\n\tawait API.updateUI();\n}\n\n'
        },
        {
            name: "calculateConnectorDistances",
            code: 'async function calculateConnectorDistances() {\n\tconst connectors = scene.getConnectors();\n\tfor (let i = 0; i < connectors.length; i++) {\n\t\tfor (let j = i + 1; j < connectors.length; j++) {\n\t\t\tconst distance = connectors[i].position.distanceTo(connectors[j].position);\n\t\t\tconsole.log(`Distance between ${connectors[i].userData.label} and ${connectors[j].userData.label}: ${distance.toFixed(2)}`);\n\t\t}\n\t}\n}\n\n'
        }
    ];

    public snippets = [
        {
            name: "head1",
            values: [
                ["INPUTID", "TYP", "PARAMETERS", "VALIDATED", "", "", "LABEL", "UNIT", "", "", "", "", "", "PARENT", ""],
            ],
            format: [
                ["head1_cell", "head1_cell", "head1_cell", "head1_cell", "head1_cell", "head1_cell", "head1_cell", "head1_cell", "head1_cell", "head1_cell", "head1_cell", "head1_cell", "head1_cell", "head1_cell", "head1_cell"],
            ]
        },



        // input widgets
        // 'label', 'textbox', 'number', 'image', 'select', 'checkbox','slider', 'expansion', 'tab','stepper','window'

        {
            name: "label",
            values: [
                ["label", "mylabel", "=##", "", "Label", true]
            ],
            format: [
                ["typ_cell", "parameters_cell", "value_cell", "validated_cell", "parameters_cell", "parameters_cell"],
            ]
        },
        {
            name: "textbox",
            values: [
                ["textbox", "mytext", "=##", "", "Textbox", true] // ## ersetzt das Feld durch die Zellenadresse beim Einfügen
            ],
            format: [
                ["typ_cell", "parameters_cell", "value_cell", "validated_cell", "parameters_cell", "parameters_cell"],
            ]
        },
        {
            name: "number",
            values: [
                ["number", "5", "=IF(##<0;0;##)", "", "Number", true] // ## ersetzt das Feld durch die Zellenadresse beim Einfügen
            ],
            format: [
                ["typ_cell", "parameters_cell", "value_cell", "validated_cell", "parameters_cell", "parameters_cell"],
            ]
        },
        {
            name: "image",
            values: [
                ["image", "dummyimage.png", "=##", "", "Image", true]
            ],
            format: [
                ["typ_cell", "parameters_cell", "value_cell", "validated_cell", "parameters_cell", "parameters_cell"],
            ]
        },
        {
            name: "select",
            values: [
                ["select", "entry1", '=##', "", "Select", true, "", "", "entry1;entry2;entry3"] // if-Verschachtelung zu kompliziert?
            ],
            format: [
                ["typ_cell", "parameters_cell", "value_cell", "validated_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell"],
            ]
        },
        {
            name: "checkbox",
            values: [
                ["checkbox", false, "=##", "", "Checkbox", true] // ## ersetzt das Feld durch die Zellenadresse beim Einfügen
            ],
            format: [
                ["typ_cell", "parameters_cell", "value_cell", "validated_cell", "parameters_cell", "parameters_cell"],
            ]
        },
        {
            name: "radio",
            values: [
                ["radio", false, "=##", "", "Radio", true] // ## ersetzt das Feld durch die Zellenadresse beim Einfügen
            ],
            format: [
                ["typ_cell", "parameters_cell", "value_cell", "validated_cell", "parameters_cell", "parameters_cell"],
            ]
        },
        {
            name: "slider",
            values: [
                ["slider", 5, "=##", "", "Slider", true, 0, 10] // ## ersetzt das Feld durch die Zellenadresse beim Einfügen
            ],
            format: [
                ["typ_cell", "parameters_cell", "value_cell", "validated_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell"],
            ]
        },
        {
            name: "colorchooser",
            values: [
                ["colorchooser", "#442200", "=##", "", "Color", true, 0, 10] // ## ersetzt das Feld durch die Zellenadresse beim Einfügen
            ],
            format: [
                ["typ_cell", "parameters_cell", "value_cell", "validated_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell"],
            ]
        },
        {
            name: "colorchooser (predefined palette)",
            values: [
                ["colorchooser", "#FF0000", "=##", "", "Color Palette", true, 0, 10, "#FF0000;#00FF00;#0000FF;#FFFF00;#FF00FF;#00FFFF;#FFFFFF;#000000;#808080;#FFA500;#800080;#008000;#FFC0CB;#A52A2A;#000080;#FFFF80"] // Selected value in col 1, palette in col 8
            ],
            format: [
                ["typ_cell", "parameters_cell", "value_cell", "validated_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell"],
            ]
        },
        {
            name: "colorchooser (custom colors)",
            values: [
                ["colorchooser", "#FF0000", "=##", "", "Custom Colors", true, 0, 10, "#FF0000;#00FF00;#0000FF;#FFFF00;#FF00FF;#00FFFF;#FFFFFF;#000000"] // Selected value in col 1, custom palette in col 8
            ],
            format: [
                ["typ_cell", "parameters_cell", "value_cell", "validated_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell"],
            ]
        },
        {
            name: "expansion",
            values: [
                ["expansion", "1", "=##", "", "Expansion", true] // ## ersetzt das Feld durch die Zellenadresse beim Einfügen
            ],
            format: [
                ["typ_cell", "parameters_cell", "value_cell", "validated_cell", "parameters_cell", "parameters_cell"],
            ]
        },
        {
            name: "tab",
            values: [
                ["tab", "1", "=##", "", "Tab", true] // ## ersetzt das Feld durch die Zellenadresse beim Einfügen
            ],
            format: [
                ["typ_cell", "parameters_cell", "value_cell", "validated_cell", "parameters_cell", "parameters_cell"],
            ]
        },
        {
            name: "stepper",
            values: [
                ["stepper", "1", "=##", "", "Stepper", true] // ## ersetzt das Feld durch die Zellenadresse beim Einfügen
            ],
            format: [
                ["typ_cell", "parameters_cell", "value_cell", "validated_cell", "parameters_cell", "parameters_cell"],
            ]
        },
        {
            name: "window",
            values: [
                ["window", "1", "=##", "", "Window", true] // ## ersetzt das Feld durch die Zellenadresse beim Einfügen
            ],
            format: [
                ["typ_cell", "parameters_cell", "value_cell", "validated_cell", "parameters_cell", "parameters_cell"],
            ]
        },
        {
            name: "html",
            values: [
                ["html", "<strong style='color:red;font-size:20px;font-style:italic;'>Hello World</strong>", "=##", "", "HTML", true] // ## ersetzt das Feld durch die Zellenadresse beim Einfügen
            ],
            format: [
                ["typ_cell", "parameters_cell", "value_cell", "validated_cell", "parameters_cell", "parameters_cell"],
            ]
        },
        {
            name: "button",
            values: [
                ["button", "1", "=##", "", "Button", true] // ## ersetzt das Feld durch die Zellenadresse beim Einfügen
            ],
            format: [
                ["typ_cell", "parameters_cell", "value_cell", "validated_cell", "parameters_cell", "parameters_cell"],
            ]
        },
        {
            name: "savebutton",
            values: [
                ["button", "save", "save", "", "Save", true] // ## ersetzt das Feld durch die Zellenadresse beim Einfügen
            ],
            format: [
                ["typ_cell", "parameters_cell", "value_cell", "validated_cell", "parameters_cell", "parameters_cell"],
            ]
        },
        {
            name: "exportbutton",
            values: [
                ["button", "export", "export", "", "Export", true] // ## ersetzt das Feld durch die Zellenadresse beim Einfügen
            ],
            format: [
                ["typ_cell", "parameters_cell", "value_cell", "validated_cell", "parameters_cell", "parameters_cell"],
            ]
        },
        {
            //            timer23	timer	40		6.10780000000075		true
            name: "timer",
            values: [
                ["timer", "40", "=##", "", "Timer", true] // ## ersetzt das Feld durch die Zellenadresse beim Einfügen
            ],
            format: [
                ["typ_cell", "parameters_cell", "value_cell", "validated_cell", "parameters_cell", "parameters_cell"],
            ]
        },

        // 3d outputs
        {
            name: "line",
            values: [
                ["", "p1", "p2", "width", "material", "x", "y", "z", "rx", "ry", "rz"],
                ["line", "(0,0,50)", "(0,100,50)", 5, "black", 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Line",
                link: "https://confbuild.com/documentation/",
                params: [
                    { name: 'p1', info: 'Start point, Format: (x,y,z)' },
                    { name: 'p2', info: 'End point, Format: (x,y,z)' },
                    { name: 'width', info: 'Width, Format (x)' },
                    { name: 'material', info: 'test' },
                    { name: 'x,y,z...', info: 'position, scale, rotation' },
                ]
            }
        },
        {
            name: "shape",
            values: [
                ["", "points", "splinePath", "splineDivisions", "depth", "material", "x", "y", "z", "rx", "ry", "rz"],
                ["shape", "(0,0);(0,100);(50,100);(0,50)", "" /*splinePath e.g., "(10,10);(50,80);(100,20)"*/, "" /*splineDivisions e.g., 30*/, 10 /*depth*/, "#445566", 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell"/*points*/, "parameters_cell"/*splinePath*/, "parameters_cell"/*splineDivisions*/, "parameters_cell"/*depth*/, "parameters_cell"/*material*/, "standard_parameters_cell"/*x*/, "standard_parameters_cell"/*y*/, "standard_parameters_cell"/*z*/, "standard_parameters_cell"/*rx*/, "standard_parameters_cell"/*ry*/, "standard_parameters_cell"/*rz*/]
            ],
            infos: {
                header: "Shape (2D base for extrusion)",
                link: "https://confbuild.com/documentation-shape",
                params: [
                    { name: 'points', info: 'Defines direct vertices for a polygonal shape. Format: (x1,y1);(x2,y2);... Used if splinePath is not provided or invalid.' },
                    { name: 'splinePath', info: 'Optional. Defines control points for a Catmull-Rom spline to generate the shape outline. Format: (x1,y1);(x2,y2);... If provided (with >=2 points), this will be used instead of \'points\'.' },
                    { name: 'splineDivisions', info: 'Optional. Number of points to generate along the spline. Higher numbers create a smoother curve. Defaults to a heuristic if not set (e.g., 20, or control_point_count * 10).' },
                    { name: 'depth', info: 'Depth of the extrusion for the 2D shape.' },
                    { name: 'material', info: 'Material/color of the shape. Format: #RRGGBB or #RRGGBB;roughness;metalness;transparent;opacity' },
                    { name: 'x,y,z...', info: 'Position, scale, rotation of the extruded shape. (sx,sy,sz for scale)' },
                ]
            }

        },
        {
            name: "shape (mixed)",
            values: [
                ["", "points", "segments", "splinePath", "splineDivisions", "depth", "material", "x", "y", "z", "rx", "ry", "rz"],
                ["shape", "(0,0);(100,0);(100,100);(0,100)", "line:(0,0)-(100,0);spline:(100,0)-(100,100)-(0,100);line:(0,100)-(0,0)", "" /*legacy splinePath*/, 30 /*splineDivisions*/, 10 /*depth*/, "#445566", 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell"/*points*/, "parameters_cell"/*segments*/, "parameters_cell"/*splinePath*/, "parameters_cell"/*splineDivisions*/, "parameters_cell"/*depth*/, "parameters_cell"/*material*/, "standard_parameters_cell"/*x*/, "standard_parameters_cell"/*y*/, "standard_parameters_cell"/*z*/, "standard_parameters_cell"/*rx*/, "standard_parameters_cell"/*ry*/, "standard_parameters_cell"/*rz*/]
            ],
            infos: {
                header: "Shape with Mixed Line/Spline Segments",
                link: "https://confbuild.com/documentation-shape-mixed",
                params: [
                    { name: 'points', info: 'Fallback vertices for simple polygonal shape. Used if segments is not provided.' },
                    { name: 'segments', info: 'Mixed segments definition. Format: line:(x1,y1)-(x2,y2);spline:(x1,y1)-(x2,y2)-(x3,y3);circle:(cx,cy,radius)' },
                    { name: 'splinePath', info: 'Legacy spline control points. Superseded by segments parameter.' },
                    { name: 'splineDivisions', info: 'Number of points to generate along spline segments. Higher numbers create smoother curves.' },
                    { name: 'depth', info: 'Depth of the extrusion for the 2D shape.' },
                    { name: 'material', info: 'Material/color of the shape. Format: #RRGGBB or #RRGGBB;roughness;metalness;transparent;opacity' },
                    { name: 'x,y,z...', info: 'Position, scale, rotation of the extruded shape. (sx,sy,sz for scale)' },
                ]
            }
        },
        {
            name: "shape (circle hole)",
            values: [
                ["", "shapeType", "center", "radius", "depth", "material", "x", "y", "z", "rx", "ry", "rz"],
                ["shape", "circle", "(50,50)", 25, 10, "#445566", 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell"/*shapeType*/, "parameters_cell"/*center*/, "parameters_cell"/*radius*/, "parameters_cell"/*depth*/, "parameters_cell"/*material*/, "standard_parameters_cell"/*x*/, "standard_parameters_cell"/*y*/, "standard_parameters_cell"/*z*/, "standard_parameters_cell"/*rx*/, "standard_parameters_cell"/*ry*/, "standard_parameters_cell"/*rz*/]
            ],
            infos: {
                header: "Circular Shape (Perfect for Holes)",
                link: "https://confbuild.com/documentation-shape-circle",
                params: [
                    { name: 'shapeType', info: 'Set to "circle" for circular shapes' },
                    { name: 'center', info: 'Center point of the circle. Format: (x,y)' },
                    { name: 'radius', info: 'Radius of the circle' },
                    { name: 'depth', info: 'Depth of the extrusion for the circular shape' },
                    { name: 'material', info: 'Material/color of the shape. Format: #RRGGBB or #RRGGBB;roughness;metalness;transparent;opacity' },
                    { name: 'x,y,z...', info: 'Position, scale, rotation of the extruded shape. (sx,sy,sz for scale)' },
                ]
            }
        },
        {
            name: "image3d",
            values: [
                ["", "filename", "width", "height", "material", "x", "y", "z", "rx", "ry", "rz"],
                ["image3d", "dummy.png", 300, 200, "#555555", 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Image",
                link: "https://confbuild.com/documentation/",
                params: [
                    { name: 'x,y,z...', info: 'position, scale, rotation' },
                    { name: 'filename', info: 'The filename of the image' },
                    { name: 'width', info: 'The width of the image' },
                    { name: 'height', info: 'The height of the image' },
                ]
            }

        }, {
            name: "surface",
            values: [
                ["", "points", "indices", "material", "x", "y", "z", "rx", "ry", "rz"],
                ["surface", "(0,0,0);(0,0,0);(0,0,0);(0,0,0);(0,0,0)", "(1,2,3)", "#550000", 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Surface",
                link: "https://confbuild.com/documentation/",
                params: [
                    { name: 'points', info: 'List of points, Format: (x1, y1, z1);(x2, y2, z2); ...' },
                    { name: 'indices', info: 'List of point indices, 3 indices create a tringale' },
                    { name: 'material', info: '' },
                    { name: 'x,y,z...', info: 'position, scale, rotation' },
                ]
            }

        },
        {
            name: "cube",
            values: [
                ["", "width", "length", "height", "material", "x", "y", "z", "rx", "ry", "rz"],
                ["cube", 100, 100, 100, "#550000", 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Cube",
                link: "https://confbuild.com/documentation-cube",
                params: [
                    { name: 'width', info: 'width off the cube' },
                    { name: 'length', info: 'length off the cube' },
                    { name: 'height', info: 'height off the cube' },
                    { name: 'material', info: 'The material' },
                    { name: 'x,y,z...', info: 'position, scale, rotation' },
                ]
            }
        },

        {
            name: "sphere",
            values: [
                ["", "radius", "material", "x", "y", "z", "rx", "ry", "rz"],
                ["sphere", 10, "#550000", 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Sphere",
                link: "https://confbuild.com/documentation-sphere",
                params: [
                    { name: 'Radius', info: 'radius off the sphere' },
                    { name: 'material', info: 'The material' },
                    { name: 'x,y,z...', info: 'position, scale, rotation' },
                ]
            }
        },

        {
            name: "capsule",
            values: [
                ["", "radius", "length", "capSubdivisions", "radialSegments", "material", "x", "y", "z", "rx", "ry", "rz"],
                ["capsule", 10, 20, 4, 8, "#445566", 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Capsule",
                link: "https://confbuild.com/documentation-capsule",
                params: [
                    { name: 'radius', info: 'The radius of the capsule' },
                    { name: 'length', info: 'The length of the middle section' },
                    { name: 'capSubdivisions', info: 'Number of curve segments used to build the caps' },
                    { name: 'radialSegments', info: 'Number of segmented faces around the circumference' },
                    { name: 'material', info: 'The material' },
                    { name: 'x,y,z...', info: 'position, scale, rotation' },
                ]
            }
        },

        {
            name: "extrusion",
            values: [
                ["", "baseplane", "extrusionvector", "material", "bevelwidth", "bevelsegments", "x", "y", "z", "rx", "ry", "rz"],
                ["extrusion", "(0,0);(100,0);(200,100);(0,100)", "(0,0,300)", "#445566", 0, 1, 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Extrusion",
                link: "https://confbuild.com/documentation-extrusion",
                params: [
                    { name: 'baseplane', info: 'Defines the 2D shape to be extruded in the XY plane. Format: (x1,y1);(x2,y2);... Points define a closed polygon.' },
                    { name: 'extrusionvector', info: 'Direction and length of extrusion. Format: (x,y,z). Z component MUST be non-zero. For standard vertical extrusions, only use Z component (e.g. (0,0,100)). X,Y components create sheared extrusions.' },
                    { name: 'material', info: 'Material/color of the extruded shape' },
                    { name: 'bevelwidth', info: 'Width of the bevel applied to edges. 0 means no bevel.' },
                    { name: 'bevelsegments', info: 'Number of segments for the bevel curve.' },
                    { name: 'x,y,z', info: 'Position of the extrusion base in 3D space' },
                    { name: 'rx,ry,rz', info: 'Rotation angles in degrees. Applied after extrusion to orient the final shape.' },
                ]
            }

        },

        {
            name: "cylinder",
            values: [
                ["", "radiusTop", "radiusBottom", "height", "material", "x", "y", "z", "rx", "ry", "rz"],
                ["cylinder", 50, 50, 200, "#445566", 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Cylinder",
                link: "https://confbuild.com/documentation-cylinder",
                params: [
                    { name: 'radiusTop', info: 'radius on the top' },
                    { name: 'radiusBottom', info: 'radius on the bottom' },
                    { name: 'height', info: 'the height/length' },
                    { name: 'material', info: 'The material' },
                    { name: 'x,y,z...', info: 'position, scale, rotation' },
                ]
            }

        },
        {
            name: "lathe",
            values: [
                ["", "points", "material", "x", "y", "z", "rx", "ry", "rz"],
                ["lathe", "(0,0);(100,0);(0,100)", "#445566", 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Lathe",
                link: "https://confbuild.com/documentation/",
                params: [
                    { name: 'points', info: '' },
                    { name: 'material', info: 'The material' },
                    { name: 'x,y,z...', info: 'position, scale, rotation' },
                ]
            }
        },

        {
            name: "arrow",
            values: [
                ["", "start", "end", "width", "material", "headLength", "headWidth", "x", "y", "z", "rx", "ry", "rz"],
                ["arrow", "(0,0,0)", "(100,0,0)", 2, "#000000", 10, 5, 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Arrow",
                link: "https://confbuild.com/documentation/",
                params: [
                    { name: 'start', info: 'Start point of the arrow, Format: (x,y,z)' },
                    { name: 'end', info: 'End point of the arrow, Format: (x,y,z)' },
                    { name: 'width', info: 'Width of the arrow line' },
                    { name: 'material', info: 'Color of the arrow' },
                    { name: 'headLength', info: 'Length of the arrow head' },
                    { name: 'headWidth', info: 'Width of the arrow head' },
                    { name: 'x,y,z...', info: 'position, scale, rotation' },
                ]
            }
        },

        {
            name: "union",
            values: [
                ["", "mergedoutputids", "x", "y", "z", "rx", "ry", "rz"],
                ["union", "object1,object2", 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Union (CSG)",
                link: "https://confbuild.com/documentation-union",
                params: [
                    { name: 'mergedoutputids', info: 'Comma-separated list of OutputIDs of objects to merge (e.g., "cube1,sphere1")' },
                    { name: 'x,y,z...', info: 'Position/rotation are ignored as transforms are baked into the geometry from original objects.' },
                ]
            }
        },

        {
            name: "subtraction",
            values: [
                ["", "cuttedoutputids", "cutoutputids", "x", "y", "z", "rx", "ry", "rz"],
                ["subtraction", "extrusion1,extursion2", "extrusion3", 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "subtraction",
                link: "https://confbuild.com/documentation-subtraction",
                params: [
                    { name: 'cuttedoutputids', info: 'List of  Ids of cutted objects' },
                    { name: 'cutoutputids', info: 'List of objects which cut' },
                    { name: 'x,y,z...', info: 'position, scale, rotation' },
                ]
            }
        },
        {
            name: "textflat",
            values: [
                ["", "textflat", "fontsize", "color", "align", "x", "y", "z", "rx", "ry", "rz"],
                ["textflat", "Your Text", 8, "#222222", "center", 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Textflat",
                link: "https://confbuild.com/documentation/",
                params: [
                    { name: 'textflat', info: 'The text (content)' },
                    { name: 'fontsize', info: 'size' },
                    { name: 'color', info: 'the color' },
                    { name: 'align', info: 'text alignment (left, center, right)' },
                    { name: 'x,y,z...', info: 'position, scale, rotation' },
                ]
            }
        },

        {
            name: "group",
            values: [
                ["", "outputids", "x", "y", "z", "rx", "ry", "rz"],
                ["group", "extrusion1,extrusion2", 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Group",
                link: "https://confbuild.com/documentation/",
                params: [
                    { name: 'outputids', info: 'List of  Ids of objects' },
                    { name: 'x,y,z...', info: 'position, scale, rotation' },
                ]
            }
        },
        {
            name: "ibeam",
            values: [
                ["", "profile", "width", "height", "length", "flangeThickness", "webThickness", "material", "startSlope", "endSlope", "x", "y", "z", "rx", "ry", "rz"],
                ["ibeam", "IPE 200", "", "", "150", "", "", "#445566", "0", "0", 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "I-Beam",
                link: "https://confbuild.com/documentation-i-beam",
                params: [
                    { name: 'profile', info: 'Standard profile (e.g., "IPE 200", "HEA 180", "HEB 220") - leave empty for custom dimensions' },
                    { name: 'width', info: 'Total width of the I-beam (only used if profile is not specified)' },
                    { name: 'height', info: 'Total height of the I-beam (only used if profile is not specified)' },
                    { name: 'length', info: 'Length of the I-beam' },
                    { name: 'flangeThickness', info: 'Thickness of the flanges (only used if profile is not specified)' },
                    { name: 'webThickness', info: 'Thickness of the web (only used if profile is not specified)' },
                    { name: 'material', info: 'Material color/texture' },
                    { name: 'startSlope', info: 'Angle in degrees for the cut at the start of the beam (0 = perpendicular)' },
                    { name: 'endSlope', info: 'Angle in degrees for the cut at the end of the beam (0 = perpendicular)' },
                    { name: 'x,y,z', info: 'Position coordinates' },
                    { name: 'rx,ry,rz', info: 'Rotation angles' }
                ]
            }
        },
        {
            name: "aluprofile",
            values: [
                ["", "series", "size", "length", "material", "x", "y", "z", "rx", "ry", "rz"],
                ["aluprofile", "ITEM", "ITEM-40x40-8", 1000, "#A4A4A4", 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Aluminum Profile",
                link: "https://confbuild.com/documentation-aluminum-profile",
                params: [
                    { name: 'series', info: 'Profile series (BASIC, LIGHT, HEAVY, ECONOMIC, DIN, ISO, INDUSTRIAL, ITEM)' },
                    { name: 'size', info: 'Profile size designation (e.g., "ITEM-40x40-8", "DIN-30x30")' },
                    { name: 'length', info: 'Length of the profile in mm' },
                    { name: 'material', info: 'Material color/texture' },
                    { name: 'x,y,z', info: 'Position coordinates' },
                    { name: 'rx,ry,rz', info: 'Rotation angles' }
                ]
            }
        },


        {
            name: "light",
            values: [
                ["", "lighttype", "color", "intensity", "distance", "decay", "angle", "penumbra", "groundColor", "width", "height", "x", "y", "z", "rx", "ry", "rz"],
                ["light", "point", "#ffffff", 1, 0, 2, 0.3, 0, "#444444", 100, 100, 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Light",
                link: "https://confbuild.com/documentation-light",
                params: [
                    { name: 'lighttype', info: 'Type of light: "point", "spot", "directional", "ambient", "hemisphere", "rectarea"' },
                    { name: 'color', info: 'Light color in hex format (e.g., #ffffff for white)' },
                    { name: 'intensity', info: 'Light intensity, typically 0-1 for physically correct results' },
                    { name: 'distance', info: 'Maximum range of the light (0 = infinite) - for point and spot lights' },
                    { name: 'decay', info: 'Amount the light dims along the distance (default: 2) - for point and spot lights' },
                    { name: 'angle', info: 'Maximum angle of light dispersion in radians - for spot lights only' },
                    { name: 'penumbra', info: 'Percent of the spotlight cone that is attenuated due to penumbra (0-1) - for spot lights only' },
                    { name: 'groundColor', info: 'Color from below in hex format - for hemisphere lights only' },
                    { name: 'width', info: 'Width of the light source - for rectarea lights only' },
                    { name: 'height', info: 'Height of the light source - for rectarea lights only' },
                    { name: 'x,y,z', info: 'Position of the light' },
                    { name: 'rx,ry,rz', info: 'Rotation - important for directional, spot, and rectarea lights' }
                ]
            }
        },
        {
            name: "pointlight",
            values: [
                ["", "color", "intensity", "distance", "decay", "x", "y", "z"],
                ["pointlight", "#ffffff", 1, 0, 2, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Point Light",
                link: "https://confbuild.com/documentation-pointlight",
                params: [
                    { name: 'color', info: 'Light color in hex format (e.g., #ffffff for white)' },
                    { name: 'intensity', info: 'Light intensity, typically 0-1 for physically correct results' },
                    { name: 'distance', info: 'Maximum range of the light (0 = infinite)' },
                    { name: 'decay', info: 'Amount the light dims along the distance of the light (default: 2)' },
                    { name: 'x,y,z', info: 'Position of the light' }
                ]
            }
        },
        {
            name: "spotlight",
            values: [
                ["", "color", "intensity", "distance", "angle", "penumbra", "decay", "x", "y", "z", "rx", "ry", "rz"],
                ["spotlight", "#ffffff", 1, 0, 0.3, 0, 2, 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Spot Light",
                link: "https://confbuild.com/documentation-spotlight",
                params: [
                    { name: 'color', info: 'Light color in hex format (e.g., #ffffff for white)' },
                    { name: 'intensity', info: 'Light intensity, typically 0-1 for physically correct results' },
                    { name: 'distance', info: 'Maximum range of the light (0 = infinite)' },
                    { name: 'angle', info: 'Maximum angle of light dispersion from its direction (in radians)' },
                    { name: 'penumbra', info: 'Percent of the spotlight cone that is attenuated due to penumbra (0-1)' },
                    { name: 'decay', info: 'Amount the light dims along the distance of the light (default: 2)' },
                    { name: 'x,y,z', info: 'Position of the light' },
                    { name: 'rx,ry,rz', info: 'Rotation to aim the spotlight' }
                ]
            }
        },
        {
            name: "directionallight",
            values: [
                ["", "color", "intensity", "x", "y", "z", "rx", "ry", "rz"],
                ["directionallight", "#ffffff", 1, 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Directional Light",
                link: "https://confbuild.com/documentation-directionallight",
                params: [
                    { name: 'color', info: 'Light color in hex format (e.g., #ffffff for white)' },
                    { name: 'intensity', info: 'Light intensity, typically 0-1 for physically correct results' },
                    { name: 'x,y,z', info: 'Position of the light' },
                    { name: 'rx,ry,rz', info: 'Rotation determining the direction of the light' }
                ]
            }
        },
        {
            name: "ambientlight",
            values: [
                ["", "color", "intensity", "x", "y", "z"],
                ["ambientlight", "#ffffff", 0.5, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Ambient Light",
                link: "https://confbuild.com/documentation-ambientlight",
                params: [
                    { name: 'color', info: 'Light color in hex format (e.g., #ffffff for white)' },
                    { name: 'intensity', info: 'Light intensity, typically 0-1 for physically correct results' },
                    { name: 'x,y,z', info: 'Position of the light (note: ambient light illuminates all objects equally)' }
                ]
            }
        },
        {
            name: "hemispherelight",
            values: [
                ["", "skyColor", "groundColor", "intensity", "x", "y", "z"],
                ["hemispherelight", "#ffffff", "#444444", 1, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Hemisphere Light",
                link: "https://confbuild.com/documentation-hemispherelight",
                params: [
                    { name: 'skyColor', info: 'Color of the light from above (sky) in hex format' },
                    { name: 'groundColor', info: 'Color of the light from below (ground) in hex format' },
                    { name: 'intensity', info: 'Light intensity, typically 0-1 for physically correct results' },
                    { name: 'x,y,z', info: 'Position of the light' }
                ]
            }
        },
        {
            name: "rectarealight",
            values: [
                ["", "color", "intensity", "width", "height", "x", "y", "z", "rx", "ry", "rz"],
                ["rectarealight", "#ffffff", 1, 100, 100, 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Rectangular Area Light",
                link: "https://confbuild.com/documentation-rectarealight",
                params: [
                    { name: 'color', info: 'Light color in hex format (e.g., #ffffff for white)' },
                    { name: 'intensity', info: 'Light intensity, typically 0-1 for physically correct results' },
                    { name: 'width', info: 'Width of the rectangular light source' },
                    { name: 'height', info: 'Height of the rectangular light source' },
                    { name: 'x,y,z', info: 'Position of the light' },
                    { name: 'rx,ry,rz', info: 'Rotation to aim the area light' }
                ]
            }
        },
        {
            name: "gltf",
            values: [
                ["", "filename", "x", "y", "z", "rx", "ry", "rz", "sx", "sy", "sz"],
                ["gltf", "/assets/test.gltf", 0, 0, 0, 0, 0, 0, 1, 1, 1],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "gltf/glb 3D File",
                link: "https://confbuild.com/documentation-gltf",
                params: [
                    { name: 'filename', info: 'url of the file' },
                    { name: 'x,y,z...', info: 'position, scale, rotation' },
                    { name: 'node=[name]', info: 'name of the gltf node, property e.g.: "visible=FALSE"' }
                ]
            }
        },
        // ---------------- overlays ------------------
        {
            name: "overlay",
            values: [
                ["", "width", "height", "backgroundcolor", "x", "y"],
                ["overlay", "80%", "400px", "#ffffff", 0, 0],
            ],
            format: [
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Overlay",
                link: "https://confbuild.com/documentation/",
                params: [
                    { name: 'width', info: 'rectangle width of background' },
                    { name: 'height', info: 'rectangle height of background' },
                    { name: 'backgroundcolor', info: 'the background color' },
                    { name: 'material', info: 'The material' },
                    { name: 'x,y', info: 'position' },
                ]
            }
        },
        {
            name: "overlayhtml",
            values: [
                ["", "html", "x", "y"],
                ["overlayhtml", "<div>Hello World</div>", 0, 0],
            ],
            format: [
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell"]
            ],
            infos: {
                header: "Overlay HTML",
                link: "https://confbuild.com/documentation/",
                params: [
                    { name: 'html', info: 'html code' },
                    { name: 'x,y', info: 'position' },
                ]
            }
        },
        {
            name: "chart",
            values: [
                ["", "width", "height", "backgroundcolor", "type", "values", "x", "y"],
                ["chart", "600px", "400px", "#ffffff", "bar", "A2:D7", 0, 0],
            ],
            format: [
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Chart",
                link: "https://confbuild.com/documentation/",
                params: [
                    { name: 'width', info: 'radius on the top' },
                    { name: 'height', info: 'radius on the bottom' },
                    { name: 'backgroundcolor', info: 'the height/length' },
                    { name: 'type', info: 'bar chart' },
                    { name: 'values', info: 'cell range of values, format  ([topleft cell]:[rightdown cell])' },
                    { name: 'x,y', info: 'position' },
                ]
            }
        },

        //https://docs.google.com/spreadsheets/d/1SW_Ic11KG-GsFqQziNL9n9ROAzLugXCCf6bzxDA5O-0/edit#gid=0
        // line2D
        // circle2D
        // polyline2D
        // path2D
        // group
        //test
        {
            name: "rectangle2d",
            values: [
                ["", "width", "height", "backgroundcolor", "border", "bordercolor", "x", "y"],
                ["rectangle2d", "400px", "150px", "#dddddd", "2px", "#bbbbbb", 0, 0],
            ],
            format: [
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ]
        },
        {
            name: "text2d",
            values: [
                ["", "text", "width", "height", "color", "fontsize", "backgroundcolor", "x", "y"],
                ["text2d", "yourtext", "200px", "100px", "#000000", "22px", "#ffffff", 0, 0],
            ],
            format: [
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ]
        },
        {
            name: "image2d",
            values: [
                ["", "width", "height", "url", "x", "y"],
                ["image", "400px", "300px", "", 0, 0],
            ],
            format: [
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ]
        },

        {
            name: "connector",
            values: [
                ["", "label", "type", "activator", "inparent", "context", "refpos", "refrot", "x", "y", "z", "rx", "ry", "rz", "sx", "sy", "sz"],
                ["connector", "+", "sphere", "cube11", "menu1", false, "", "", 0, 0, 0, 0, 0, 0, 1, 1, 1],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Connector Point",
                link: "https://confbuild.com/documentation/",
                params: [
                    { name: 'label', info: 'label of the connector' },
                    { name: 'type', info: 'connector type: "sphere" (default), "sprite", or "both"' },
                    { name: 'activator', info: 'object that activates this connector' },
                    { name: 'inparent', info: 'parent object reference' },
                    { name: 'context', info: 'context menu or interaction context' },
                    { name: 'x,y,z', info: 'Position of the connector point' },
                    { name: 'rx,ry,rz', info: 'Rotation of the connector point' },
                    { name: 'sx,sy,sz', info: 'Scale factors' }
                ]
            }
        },

        {
            name: "dimensionline",
            values: [
                ["", "p1", "p2", "width", "material", "orthogonalLength", "orthogonalOffset", "dashed", "rotation", "textSize", "textBackground", "editcell", "x", "y", "z", "rx", "ry", "rz"],
                ["dimensionline", "(0,0,50)", "(0,100,50)", 2, "#000000", 40, 0, "false", 0, 10, "rgba(255,255,255,0.7)", "", 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Dimension Line",
                link: "https://confbuild.com/documentation/",
                params: [
                    { name: 'p1', info: 'Start point, Format: (x,y,z)' },
                    { name: 'p2', info: 'End point, Format: (x,y,z)' },
                    { name: 'width', info: 'Line width' },
                    { name: 'material', info: 'Line color' },
                    { name: 'orthogonalLength', info: 'Total length of orthogonal end lines (in world units)' },
                    { name: 'orthogonalOffset', info: 'Offset of orthogonal lines from endpoints' },
                    { name: 'dashed', info: 'true/false for dashed line style' },
                    { name: 'rotation', info: 'Rotation around line axis in degrees' },
                    { name: 'textSize', info: 'Size of dimension text' },
                    { name: 'textBackground', info: 'Background color of text sprite (rgba format)' },
                    { name: 'editcell', info: 'Cell reference to edit when clicking dimension text (e.g. "B5")' },
                    { name: 'x,y,z...', info: 'position, scale, rotation' },
                ]
            }
        },

        {
            name: "grid",
            values: [
                ["", "width", "length", "mainGap", "subGap", "nthLabel", "labelSize", "lineWidth", "mainColor", "subColor", "labelColor", "showSubLines", "showLabels", "startX", "endX", "startY", "endY", "labelOffsetX", "labelOffsetY", "x", "y", "z", "rx", "ry", "rz"],
                ["grid", 1000, 1000, 100, 50, 2, 40, 1, "#000000", "#666666", "#000000", "true", "true", "", "", "", "", 0, 0, 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Measuring Grid",
                link: "https://confbuild.com/documentation/",
                params: [
                    { name: 'width', info: 'Total width of the grid' },
                    { name: 'length', info: 'Total length of the grid' },
                    { name: 'mainGap', info: 'Distance between main grid lines' },
                    { name: 'subGap', info: 'Distance between sub grid lines' },
                    { name: 'nthLabel', info: 'Show label every nth main line' },
                    { name: 'labelSize', info: 'Size of measurement labels' },
                    { name: 'lineWidth', info: 'Width of grid lines' },
                    { name: 'mainColor', info: 'Color of main grid lines' },
                    { name: 'subColor', info: 'Color of sub grid lines' },
                    { name: 'labelColor', info: 'Color of measurement labels' },
                    { name: 'showSubLines', info: 'Show or hide sub grid lines (true/false)' },
                    { name: 'showLabels', info: 'Show or hide measurement labels (true/false)' },
                    { name: 'startX', info: 'Start X coordinate for partial grid (optional)' },
                    { name: 'endX', info: 'End X coordinate for partial grid (optional)' },
                    { name: 'startY', info: 'Start Y coordinate for partial grid (optional)' },
                    { name: 'endY', info: 'End Y coordinate for partial grid (optional)' },
                    { name: 'labelOffsetX', info: 'Value added to X-axis labels (e.g., 100 will shift labels from -500..500 to -400..600)' },
                    { name: 'labelOffsetY', info: 'Value added to Y-axis labels (e.g., 100 will shift labels from -500..500 to -400..600)' },
                    { name: 'x,y,z...', info: 'position, scale, rotation' },
                ]
            }
        },

        {
            name: "export button",
            values: [
                ["button", "Export Scene", "exportScene", "", "Export 3D Scene", true]
            ],
            format: [
                ["typ_cell", "parameters_cell", "value_cell", "validated_cell", "parameters_cell", "parameters_cell"],
            ]
        },

        {
            name: "tube",
            values: [
                ["", "path", "radius", "bendradiusfactor", "material", "x", "y", "z", "rx", "ry", "rz"],
                ["tube", "(0,0,0);(100,0,0);(100,100,0)", 10, 1.5, "#cccccc", 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Tube (with Elbows)",
                link: "https://confbuild.com/documentation-tube",
                params: [
                    { name: 'path', info: 'Sequence of points defining the tube centerline. Format: (x1,y1,z1);(x2,y2,z2);...' },
                    { name: 'radius', info: 'The radius of the tube cross-section.' },
                    { name: 'bendradiusfactor', info: 'Multiplier for radius to get bend radius (e.g., 1.5). Defines how sharp/rounded corners are.' },
                    { name: 'material', info: 'Material/color of the tube.' },
                    { name: 'x,y,z...', info: 'Position, scale, rotation of the entire tube.' },
                ]
            }
        },

        {
            name: "cable",
            values: [
                ["", "path", "diameter", "flexibility", "material", "hangFactor", "x", "y", "z", "rx", "ry", "rz"],
                ["cable", "(0,0,0);(100,100,0);(200,0,0)", 5, 1, "#000000", 0.2, 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Cable",
                link: "https://confbuild.com/documentation-cable",
                params: [
                    { name: 'path', info: 'Sequence of points defining the cable path. Format: (x1,y1,z1);(x2,y2,z2);...' },
                    { name: 'diameter', info: 'The diameter of the cable.' },
                    { name: 'flexibility', info: 'How much the cable hangs/bends under its own weight (0-2). Higher values create more sagging.' },
                    { name: 'material', info: 'Material/color of the cable.' },
                    { name: 'hangFactor', info: 'Controls the amount of hanging (0-1). 0 for straight, higher values for more droop.' },
                    { name: 'x,y,z...', info: 'Position, scale, rotation of the entire cable.' },
                ]
            }
        },

        {
            name: "ring",
            values: [
                ["", "outerRadius", "innerRadius", "depth", "material", "x", "y", "z", "rx", "ry", "rz"],
                ["ring", 100, 50, 20, "#888888", 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Ring",
                link: "https://confbuild.com/documentation-ring",
                params: [
                    { name: 'outerRadius', info: 'Outer radius of the ring.' },
                    { name: 'innerRadius', info: 'Inner radius of the ring (must be less than outerRadius).' },
                    { name: 'depth', info: 'Thickness (height) of the ring.' },
                    { name: 'material', info: 'Material/color of the ring.' },
                    { name: 'x,y,z...', info: 'Position, scale, rotation of the ring.' },
                ]
            }
        },

        {
            name: "sphere",
            values: [
                ["", "radius", "material", "x", "y", "z", "rx", "ry", "rz"],
                ["sphere", 10, "#550000", 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Sphere",
                link: "https://confbuild.com/documentation-sphere",
                params: [
                    { name: 'Radius', info: 'radius off the sphere' },
                    { name: 'material', info: 'The material' },
                    { name: 'x,y,z...', info: 'position, scale, rotation' },
                ]
            }
        },

        {
            name: "capsule",
            values: [
                ["", "radius", "length", "capSubdivisions", "radialSegments", "material", "x", "y", "z", "rx", "ry", "rz"],
                ["capsule", 10, 20, 4, 8, "#445566", 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Capsule",
                link: "https://confbuild.com/documentation-capsule",
                params: [
                    { name: 'radius', info: 'The radius of the capsule' },
                    { name: 'length', info: 'The length of the middle section' },
                    { name: 'capSubdivisions', info: 'Number of curve segments used to build the caps' },
                    { name: 'radialSegments', info: 'Number of segmented faces around the circumference' },
                    { name: 'material', info: 'The material' },
                    { name: 'x,y,z...', info: 'position, scale, rotation' },
                ]
            }
        },

        {
            name: "spring",
            values: [
                ["", "radius", "pitch", "turns", "wireRadius", "length", "material", "x", "y", "z", "rx", "ry", "rz"],
                ["spring", 20, 15, 8, 2, 150, "#445566", 0, 0, 0, 0, 0, 0],
            ],
            format: [
                ["typ_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell", "header_cell"],
                ["typ_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell", "standard_parameters_cell"]
            ],
            infos: {
                header: "Spring",
                link: "https://confbuild.com/documentation-spring",
                params: [
                    { name: 'radius', info: 'Radius of the spring coil' },
                    { name: 'pitch', info: 'Distance between coils (height per turn)' },
                    { name: 'turns', info: 'Number of turns/coils in the spring' },
                    { name: 'wireRadius', info: 'Thickness/radius of the spring wire' },
                    { name: 'length', info: 'Total length of the spring (overrides pitch calculation if specified)' },
                    { name: 'material', info: 'Material/color of the spring' },
                    { name: 'x,y,z...', info: 'Position, scale, rotation of the spring' },
                ]
            }
        },

    ]

}


export { SnippetManager }